<template>
  <section class="detail-banner">
    <div v-if="image" class="detail-banner__bg">
      <img :src="image" :alt="title || '主题详情'" />
    </div>
    <div class="detail-banner__overlay" />
    <div class="detail-banner__content">
      <div class="detail-banner__frame">
        <span class="detail-banner__corner detail-banner__corner--tl" />
        <span class="detail-banner__corner detail-banner__corner--tr" />
        <span class="detail-banner__corner detail-banner__corner--bl" />
        <span class="detail-banner__corner detail-banner__corner--br" />
        <h1 class="detail-banner__title">{{ title || '主题详情' }}</h1>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DetailBanner',
  props: {
    title: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-banner {
  position: relative;
  height: 220px;
  margin-top: $header-height;
  overflow: hidden;
  background: $color-brown-dark;

  &__bg {
    position: absolute;
    inset: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      filter: sepia(0.35) brightness(0.55);
    }
  }

  &__overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      180deg,
      rgba($color-brown-dark, 0.35) 0%,
      rgba($color-brown-dark, 0.55) 100%
    );
  }

  &__content {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  &__frame {
    position: relative;
    padding: $spacing-lg $spacing-3xl;
    border: 1px solid rgba($color-white, 0.75);
  }

  &__corner {
    position: absolute;
    width: 16px;
    height: 16px;
    border-color: rgba($color-white, 0.9);
    border-style: solid;

    &--tl { top: -1px; left: -1px; border-width: 2px 0 0 2px; }
    &--tr { top: -1px; right: -1px; border-width: 2px 2px 0 0; }
    &--bl { bottom: -1px; left: -1px; border-width: 0 0 2px 2px; }
    &--br { bottom: -1px; right: -1px; border-width: 0 2px 2px 0; }
  }

  &__title {
    font-family: $font-serif;
    font-size: rem(36);
    font-weight: 700;
    color: $color-white;
    letter-spacing: 8px;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }
}

@media (max-width: 768px) {
  .detail-banner {
    height: 160px;

    &__title {
      font-size: rem(28);
      letter-spacing: 4px;
    }

    &__frame {
      padding: $spacing-base $spacing-xl;
    }
  }
}
</style>
